<section class="page">
  <div class="page-header">
    <h1>Termin buchen</h1>
    <p>Bitte wählen Sie Versicherung, Terminart und Patientenstatus aus.</p>
  </div>

  <app-error-banner [message]="errorMessage"></app-error-banner>

  <div class="loading-state" *ngIf="isLoading">
    <mat-progress-spinner diameter="36" mode="indeterminate"></mat-progress-spinner>
    <span>Vorauswahl wird geladen…</span>
  </div>

  <div class="page-body" *ngIf="!isLoading">
    <section class="section">
      <h2>Versicherung</h2>
      <div class="option-grid two-columns">
        <button
          mat-stroked-button
          type="button"
          class="option-button"
          [class.selected]="selection.insurance?.id === option.id"
          *ngFor="let option of insuranceOptions"
          (click)="selectInsurance(option)"
        >
          {{ option.label }}
        </button>
      </div>
    </section>

    <section class="section">
      <h2>Terminart</h2>
      <div class="appointment-type-grid">
        <app-appointment-type-card
          *ngFor="let option of appointmentTypes"
          [type]="option"
          [selected]="selection.appointmentType?.id === option.id"
          (selectType)="selectAppointmentType($event)"
        ></app-appointment-type-card>
      </div>
    </section>

    <section class="section">
      <h2>Patientenstatus</h2>
      <div class="option-grid two-columns">
        <button
          mat-stroked-button
          type="button"
          class="option-button"
          [class.selected]="selection.patientStatus?.id === option.id"
          *ngFor="let option of patientStatusOptions"
          (click)="selectPatientStatus(option)"
        >
          {{ option.label }}
        </button>
      </div>
    </section>

    <div class="action-bar">
      <button mat-flat-button color="primary" [disabled]="!canContinue" (click)="continue()">
        Weiter
      </button>
    </div>
  </div>
</section>
